import '@hotwired/turbo-rails'
import 'alerts/sweetalerts'
import 'forms'
import 'mousetrap'
import 'general/json_parse_maintenance'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(utc)
dayjs.extend(advancedFormat)
window.dayjs = dayjs

// Use Rspack code splitting to load modules on demand.
// The comments are important, do not remove!

// Vendor libraries
import(/* rspackChunkName: "jquery_ui" */ '../../vendor/assets/javascripts/jquery-ui-1.10.3.full.min')
import(/* rspackChunkName: "input_mask" */ '../../vendor/assets/javascripts/jquery.inputmask.bundle')
import(/* rspackChunkName: "sentry" */ '../../vendor/assets/javascripts/sentry')
import(/* rspackChunkName: "mail_check" */ '../../vendor/assets/javascripts/mailcheck')
import(/* rspackChunkName: "blob" */ '../../vendor/assets/javascripts/Blob')
import(/* rspackChunkName: "file_saver" */ '../../vendor/assets/javascripts/FileSaver.min')
import(/* rspackChunkName: "lightbox" */ '../../vendor/assets/javascripts/simple-lightbox/simple-lightbox.min')
import(/* rspackChunkName: "jquery_card" */ '../../vendor/assets/javascripts/card/jquery.card')

import(/* rspackChunkName: "helpers" */ 'helpers')
import(/* rspackChunkName: "chosen" */ 'chosen')

import(/* rspackChunkName: "cross_domain" */ 'cross_domain')
import(/* rspackChunkName: "nprogress" */ 'nprogress')
import(/* rspackChunkName: "controllers" */ 'controllers')
import(/* rspackChunkName: "bootgrid_tables" */ 'bootgrid_tables')

import(/* rspackChunkName: "specific" */ 'specific')
import(/* rspackChunkName: "general" */ 'general')
import(/* rspackChunkName: "tailwind" */ 'tailwind')
import(/* rspackChunkName: "channels" */ 'channels')
import(/* rspackChunkName: "sanitize" */ 'sanitize')
